// Editor/seed-produced HTML always uses one of these tags, so requiring a
// known tag name keeps plain text with stray angle brackets (e.g.
// "foo<bar@x.com>") classified as plain and therefore escaped.
const KNOWN_TAG_RE =
  /<(p|br|div|span|a|ul|ol|li|h[1-6]|strong|em|b|i|u|s|blockquote|code|pre|hr|img|table)\b[^>]*\/?>/i;

/** Heuristic: does a stored value already contain HTML markup? */
export function looksLikeHtml(value: string): boolean {
  return KNOWN_TAG_RE.test(value);
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * On-ramp for legacy plain-text values loaded into the rich-text editor:
 * already-HTML values pass through untouched; plain text is escaped and its
 * newlines become markup (blank lines → paragraphs, single breaks → <br>), so
 * nothing collapses onto one line inside TipTap.
 */
export function textToHtml(value: string | null | undefined): string {
  const text = (value ?? "").trim();
  if (!text) return "";
  if (looksLikeHtml(text)) return text;
  return text
    .split(/\n{2,}/)
    .map((para) => `<p>${escapeHtml(para).replace(/\n/g, "<br>")}</p>`)
    .join("");
}
